<template>
  <v-container fluid class="no-padding-top">
    <v-row no-gutters>
      <v-col><div class="text-h6 white--text">Historial</div></v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="pagination"
      hide-default-footer
      :loading="!dataLoaded"
      loading-text="Cargando... Espera un momento"
      no-data-text="Sin órdenes por el momento"
      class="elevation-1"
      @click:row="handleClick">

      <v-progress-linear v-show="!dataLoaded" slot="progress" color="blue" indeterminate></v-progress-linear>
      <template v-slot:[`item.increment_id`]="{ item }">
        <div class="text-subtitle-1" v-text="item.increment_id"></div>
      </template>
      <template v-slot:[`item.customer_firstname`]="{ item }">
        <div class="text-subtitle-1 text-capitalize" v-text="`${item.customer_firstname} ${item.customer_lastname}`"></div>
      </template>
      <template v-slot:[`item.shipping_method`]="{ item }">
        <div class="text-subtitle-1 text-capitalize" v-text="getPrettyShipping(item.shipping_method)"></div>
        <div v-if="item.has_instructions">
          <v-icon>mdi-message-bulleted</v-icon>
        </div>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <div class="text-subtitle-1 text--disabled" v-text="$moment(item.created_at).format('DD/MMM/YY hh:mm a')"></div>
      </template>
      <template v-slot:footer>
        <div class="text-right">
          <v-pagination
            color="blue darken-2"
            :value="page"
            :length="totalPages"
            @input="handlePageChange">
          </v-pagination>
        </div>
      </template>

    </v-data-table>
  </v-container>
</template>

<script>
  import mixins from '../helpers/mixins';

  export default {
    name: 'HistoryList',
    mixins: [mixins],
    props: {
      items: {
        default: () => [],
        type: Array
      },
      headers: {
        default: () => [],
        type: Array
      },
      dataLoaded: {
        default: () => false,
        type: Boolean
      },
      page: {
        default: () => 0,
        type: Number
      },
      totalItems: {
        default: () => 0,
        type: Number
      },
    },
    computed: {
      totalPages() {
        return Math.ceil(this.totalItems / this.pagination.itemsPerPage);
      },
    },
    data: () => ({
      pagination: {
        itemsPerPage: 20,
        pageStart: 0,
        pageStop: 0,
        pageCount: 0,
      },
    }),
    methods: {
      handleClick(order) {
        this.showDetails(order.entity_id, order.increment_id, false);
      },
      showDetails(orderId, orderIncrementId, showAction) {
        this.$router.push({ name: 'order', params: { orderId, orderIncrementId, showAction } });
      },
      verifyOrder() {},
      handlePageChange(value) {
        this.$emit('pageChange', value);
      },
    }
  }
</script>
<style scoped></style>